import clsx from 'clsx';
import { FC } from 'react';

interface Props {
  width?: number;
  height?: number;
  className?: string;
}

export const CrossIcon: FC<Props> = (props) => {
  const { className, width = 24, height = 24 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      className={clsx(className)}
      aria-hidden
    >
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g>
          <g transform="translate(-730.000000, -360.000000) translate(247.000000, 339.000000)">
            <g>
              <g strokeWidth="5">
                <g>
                  <path
                    d="M18 0L9 8.85 18 18"
                    transform={`translate(486.000000, 24.000000) 
                        translate(-0.000000, 0.000000) 
                        translate(-0.000000, 0.000000)`}
                  />
                  <path
                    d="M9 0L0 8.85 9 18"
                    transform={`translate(486.000000, 24.000000) 
                        translate(-0.000000, 0.000000) 
                        translate(-0.000000, 0.000000) 
                        translate(4.500000, 9.000000) 
                        rotate(-180.000000) 
                        translate(-4.500000, -9.000000)`}
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
